import { render, staticRenderFns } from "./SupplierListView.vue?vue&type=template&id=fdf06712"
import script from "./SupplierListView.vue?vue&type=script&lang=js"
export * from "./SupplierListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports